import { fetch } from '@utils/utils';
import * as T from '@modules/tasks/_tasksTypes';

const getTask = ({ addError }) => async (id: string): Promise<T.Task> => {
  try {
    const response: any = await fetch(`/metropolis/api/ts/tasks/${id}`, {
      method: 'GET',
      headers: new Headers({ 'Content-Type': 'application/json' })
    });

    const json: T.Task = await response.json();

    return json;
  } catch (err) {
    addError(err.message);
    return {};
  }
};

export { getTask };



// WEBPACK FOOTER //
// ./src/modules/tasks/_tasksActions.ts